// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  gvId: __t.u64().primaryKey().name("gv_id"),
  guildId: __t.u64().name("guild_id"),
  versonaId: __t.u64().name("versona_id"),
  worldId: __t.u64().name("world_id"),
  job: __t.string(),
  recruitedBy: __t.identity().name("recruited_by"),
  lastWorkEpoch: __t.u64().name("last_work_epoch"),
  recruitedAt: __t.timestamp().name("recruited_at"),
  updatedAt: __t.timestamp().name("updated_at"),
});
